import React from "react";

// A longsword crossed with a loaded barbell. Steel for both.
// Uses currentColor so the parent can tint it (brass).
export function Emblem({ size = 56 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none"
      xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g stroke="currentColor" fill="none" strokeLinejoin="round" transform="rotate(45 32 32)">
        {/* sword: pommel + grip + crossguard + blade + tip */}
        <circle cx="32" cy="9" r="2.6" strokeWidth="2" />
        <line x1="32" y1="11.6" x2="32" y2="18" strokeWidth="2.2" />
        <line x1="25" y1="18" x2="39" y2="18" strokeWidth="2" strokeLinecap="round" />
        <line x1="32" y1="20" x2="32" y2="50" strokeWidth="2" />
        <path d="M32 50 L29.8 53 L32 57 L34.2 53 Z" strokeWidth="1.8" />
        {/* barbell: bar + sleeve caps + plates */}
        <line x1="10" y1="32" x2="54" y2="32" strokeWidth="2.2" strokeLinecap="round" />
        <line x1="10" y1="28.5" x2="10" y2="35.5" strokeWidth="2" strokeLinecap="round" />
        <line x1="54" y1="28.5" x2="54" y2="35.5" strokeWidth="2" strokeLinecap="round" />
        <rect x="14" y="23" width="6" height="18" rx="1.3" strokeWidth="2" />
        <rect x="44" y="23" width="6" height="18" rx="1.3" strokeWidth="2" />
      </g>
    </svg>
  );
}

export function Wordmark({ compact }) {
  return (
    <div className="llh-row-center">
      <span className="llh-brand-emblem">
        <Emblem size={compact ? 32 : 52} />
      </span>
      <div className="llh-brand-lines">
        <div className={compact ? "llh-brand-word llh-brand-word--compact" : "llh-brand-word"}>Leichtenauer</div>
        <div className={compact ? "llh-brand-title llh-brand-title--compact" : "llh-brand-title"}>Lift'n Hour</div>
      </div>
    </div>
  );
}
